import React from 'react';

import SettingRow from 'flow/components/Setting/SettingRow';
import SettingsBlock from 'flow/components/settings/SettingsBlock';
import Toggle from 'flow/components/ui-components/Toggle';
import useAppContext from 'flow/hooks/useAppContext';
import { Calendar } from 'flow/types/Calendar';
import { TypedMap } from 'flow/types/TypedMap';
import { twMerge } from 'tailwind-merge';

interface Props {
    calendar: TypedMap<Calendar>;
    toggleAutoMeeting: (value: boolean) => void;
    disabled: boolean;
    secondary: string;
}

const CalendarAutomeetingToggle = ({
    calendar,
    toggleAutoMeeting,
    disabled,
    secondary,
}: Props) => {
    const { i18next } = useAppContext();

    return (
        <div>
            <SettingsBlock
                className={twMerge('p-3', disabled ? '' : 'opacity-50')}
            >
                <div className="-ms-3">
                    <div className="px-3 pb-2 text-xs font-bold text-gray-800">
                        {i18next.t(
                            'settings.social_integration.calendar_settings',
                        )}
                    </div>
                </div>

                <div
                    dangerouslySetInnerHTML={{
                        __html: i18next.t(
                            'settings.social_integration.calendar_activate_info',
                        ),
                    }}
                />
            </SettingsBlock>

            <SettingRow
                cta={
                    <Toggle
                        value={disabled ? false : calendar.get('autoMeeting')}
                        onChange={toggleAutoMeeting}
                        text={i18next.t('calendar.other.external.automeeting')}
                    />
                }
                information={secondary}
                disabled={disabled}
            >
                {i18next.t('calendar.other.external.automeeting')}
            </SettingRow>
        </div>
    );
};

export default CalendarAutomeetingToggle;
